export default "__VITE_ASSET__BGA369So__"